module.exports = __webpack_public_path__ + "img/clinica-sueno.b5bf9c14.jpg";